import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { NoImageSize } from '../models';

@Component({
  selector: 'rp-no-image',
  standalone: true,
  templateUrl: './no-image.component.html',
  styleUrls: ['./no-image.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule],
})
export class NoImageComponent {
  title = input<string>('general.noImage');
  size = input<NoImageSize>('s');
}
